import CitiesList from './components/CitiesList';
import './styles/App.css';

const App = () => (
  <div className="App">
    <h1>Welcome to City Weather</h1>
    <CitiesList />
  </div>
);

export default App;
